import authRequest from "@/api/http/authRequest";
import axios from "axios";
import http from "@/api/http/http";

export default {
  createLessonAccess (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.post(`/admin/lesson-access`, params, cb, errCb)
  },
  getLessonAccesses(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.get(`/admin/lesson-accesses`, params, cb, errCb)
  },
  exelExportLessonAccess (params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.excelDownload(`/admin/lesson-accesses/excel`, params, cb, errCb)
  },
  extendExpiredAt(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.post(`/admin/lesson-access/extend`, params, cb, errCb)
  },
  setUnapproved(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.put(`/admin/lesson-access/unapproved`, params, cb, errCb)
  },
  updateLessonAccess(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.patch(`/admin/lesson-access/${params.id}`, params, cb, errCb)
  },
  createLessonAccessesByExcel( params: any, cb: (response) => void, errCb: (response) => void) {
    const formData = new FormData()
    formData.append('file', params.file)
    formData.append('accountType', params.accountType)
    formData.append('lessonId', params.lessonId)
    const header = http.setHeaders()
    axios({
      method: 'post',
      url: `${process.env.VUE_APP_API}/admin/lesson-accesses/excel`,
      responseType: 'blob',
      data: formData,
      ...header
    })
      .then(cb)
      .catch((error) => {
        console.log('error', error)
        if (error.response && error.response.data && error.response.data.message) {
          errCb(error.response.data);
        } else {
          errCb({ message: "An unknown error occurred" });
        }
      })
  },
}
